$(document).ready(function(){
	'use strict';
	if(!document.querySelector('.right-floating-bar')) return false;

	// hoisting
	var floatingbar = {};
	var floatingbanner = {};
	var recentlyView = {};
	var inPopup= true; /*LGEIN-102 20200721*/
	floatingbar = function(){
		var $this = $(".right-floating-bar"),
			$slider = $this.find(".rolling-area"),
			$dimedLayer = $this.find(".back-layer-by-mobile"),
			$list = $this.find(".bar-menu-list"),
			$counter = $this.find(".status-bundle-location"),
			// 200421 전호근 - for responsive 
			minXXL = window.matchMedia('(min-width: 1440px)'),
			p =  floatingbar.prototype;
	
		p.init = function(){
			this.preset();
			this.activeViewed();
			// 200421 START 전호근 - for responsive
			minXXL.addListener(p.resizeRFB);
			this.resizeRFB(minXXL);
			// 200421 END 전호근 - for responsive
		};

		p.eventOn = function(){
			
			$this.on("mouseleave blur", function(e){
				if(!e.relatedTarget) return false;
				p.fold();
			});

			/* LGECS-40 20200625 add */
			$list.find('a').on('click touch', function(e){
				p.adobeTrack(this, 'chatbot');
			});
			/* //LGECS-40 20200625 add */

			$list.on("mouseenter focus", function(){
				p.expand();
				p.repaintViewed();
			});

			$list.on("focus", ".recently-viewed .head-inner", function(){
				p.expand();
				p.repaintViewed();
			});

			$list.prev().attr('tabindex', 0).on({
				focus: p.fold
			});
			$this.find(".back-to-top").on({
				focus: p.fold
			});

			$this.find(".back-to-top").on("click touch", function(event){
				event.preventDefault();
				// 20200408 START 구유정 || Fix mac safari issues
				p.scrollTopToZero("html, body", 600);
				// 20200408 END 구유정 || Fix mac safari issues
			});

			$this.find(".call-bar-menu-list").on("touch click", function(event){
				event.preventDefault();
				if( $this.hasClass("active") ){
					p.listClose();
				}else{
					p.listOpen();
				}
			});
			$this.find(".call-bar-menu-list").on("blur", function(event){
				var $focusTarget = $list.find('a').eq(0);
				setTimeout(function(){
		            $focusTarget.focus();
		        }, 50);
			});

			$dimedLayer.on("click", function(){
				p.listClose();
			});

			windowFixedScroll(); ///* LGEAU-67 20200601 Changing How Support Sidebar Behaves */
			
		};
		/* LGEAU-67 20200601 Changing How Support Sidebar Behaves */
		p.eventOff = function(){
			$this.off("mouseleave blur");
			$list.off("mouseenter focus");
			$list.off("focus", ".recently-viewed .head-inner");
			$list.prev().attr('tabindex', 0).off('focus');
			$this.find(".back-to-top").off('focus');
			$this.find(".back-to-top").off("click touch");
			$this.find(".call-bar-menu-list").off("touch click");
			$this.find(".call-bar-menu-list").off("blur");
			$dimedLayer.on("click");
			$(window).off('scroll.fixedFloat');
			$list.removeClass('fold');
		};
		function windowFixedScroll() {
			$(window).on('scroll.fixedFloat', function() {
				var scroll = $(window).scrollTop();
				// fixed bar :: desktop only
				if(scroll > (416-110))  {
					$this.addClass("fixed");
				} else {
					$this.removeClass("fixed");
				}
				// fold bar :: desktop only
				if( $list.attr("class").indexOf("fold") > 0 ){
					$list.addClass("fold");
				}
			});
		}
		/* // LGEAU-67 20200601 Changing How Support Sidebar Behaves */

		/* LGECS-40 20200625 add */
		p.adobeTrack = function(target, type) {
			var $target = $(target);
			var typeCheck = false;
			var paramName = '';

			switch (type) {
				case 'chatbot':
					typeCheck = /lgvirtualagent/g.test( ($target.attr('href') || '') );
					paramName = 'start_lg_chatbot';
					break;
				default:
					break;
			}

			if (typeCheck && paramName) {
				var param = {};
				param.page_event = {};
				param.page_event[paramName] = true;
				adobeTrackEvent(paramName, param);
			}
		};
		/* //LGECS-40 20200625 add */

		p.preset = function(){
			// for mobile
			if($(window).width() <= 992) {
				p.eventOn();
			
			// for desktop
			} else {
				setTimeout(function() {
					$list.removeClass('fold');
					/* LGEAU-67 20200601 Changing How Support Sidebar Behaves */
					if ( COUNTRY_CODE === "au" ) {
						$list.find('.bar-menu:last').removeClass('to-egg');
						$this.prepend('<p class="unfold-wrap"><button type="button" class="btn-unfold-close"><span class="sr-only">close</span></button></p>');
						setTimeout(function() {
							windowFixedScroll();
							$('.btn-unfold-close').one('click',function(e){
								e.preventDefault();
								$list.addClass('fold unfold-close-check');
								p.eventOff();
								p.eventOn();
								$('.unfold-wrap').remove();
							});
						}, 300);
						$(window).on('resize load',function(){
							if ( ($(window).width() <= 1439) ) {
								p.eventOff();
								p.eventOn();
							} else {
								if ( !$list.is('.unfold-close-check') ) {
									p.eventOff();
									windowFixedScroll();
									$list.find('.bar-menu:last').removeClass('to-egg');
								} else {
									$list.addClass('fold');
								}
							}
						});
					} else {
						setTimeout(function() {
							$list.addClass('fold');
							p.eventOn();
						}, 1000);
					}
					/* // LGEAU-67 20200601 Changing How Support Sidebar Behaves */
				}, 300);
			}
		};

		p.resizeRFB = function(e) {
			// 200421 START 전호근 - Initialize floating bar according to screen size 
			if (e.matches) {
				// reset desktop layout
				p.listClose();
				$list.addClass("fold");
				$this.find(".recently-viewed").addClass("to-egg");
			} else {
				// reset tablet, mobile process
				p.listClose();
			}
			// 200421 END 전호근 - Initialize floating bar according to screen size 
		};

		p.scrollTopToZero = function(tg, motionSpeed){
			$(tg).stop().animate({
				scrollTop : 0
			}, motionSpeed);
		};

		p.expand = function(){
			$list.removeClass("fold").find(".recently-viewed").removeClass("to-egg");
		};

		p.fold = function(){
			$list.addClass("fold").find(".recently-viewed").addClass("to-egg");
		};

		p.listClose = function(){
			$this.removeClass("active");
			$dimedLayer.removeClass("active");
			$("body").removeClass("band-scroll");
		};
		
		p.listOpen = function(){
			$this.addClass("active");
			$dimedLayer.addClass("active");
			$("body").addClass("band-scroll");
		};

		p.repaintViewed = function(){
			if( $slider.hasClass("slick-slider") ){
				$slider.slick('setPosition');
			}
		};

		p.activeViewed = function(){
			/*
			if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
				// Cookie 사용 가능 시 실행할 스크립트
			} else {
				// Cookie 사용 불가
				// - load : 고정값
				// - small : small을 추가하면 위 아래 여백이 좁아짐	// - $target : 안내 메시지가 출력되어야 할 영역	 
				var $target  = $list.find('.recently-viewed');
				ePrivacyCookies.view('load', 'small', $target);
			}
			*/
			

			var sliderBundle = "<div class=\"viewed-bundle\"></div>",
				sliderItem = $slider.find(".viewed-item"),
				sliderItemLength = $slider.find(".viewed-item").length,
				pageCount = 0,
				cutbundle = {};

			// repaint DOM tree in slider. 
			for(var i=0; i<sliderItemLength/3; i++){
				var cutbundle = sliderItem.slice( (i*3), (i*3)+3 );
				$slider.append(sliderBundle);
				$slider.find(".viewed-bundle").eq(i).html(cutbundle);
			}

			// viewed count
			pageCount = $slider.find(".viewed-bundle").length;
			$this.find(".count-viewed").text(sliderItemLength);
			$this.find(".all-bundles").text(pageCount);
			if(pageCount === 0 || pageCount === undefined || pageCount === null) {
				$counter.find(".stand").text("0");
			} else {
				$counter.find(".stand").text("1");
			}
			

			// ePrivacy Cookie set
			if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
				// Cookie 사용 가능 시 실행할 스크립트
			} else {

				if ( location.hostname == 'localhost'){

				} else {
					// Cookie 사용 불가
					// - load : 고정값
					// - small : small을 추가하면 위 아래 여백이 좁아짐	// - $target : 안내 메시지가 출력되어야 할 영역	 
					$this.find(".count-viewed").text('0');
					$this.find(".all-bundles").text('0');
					$counter.find(".stand").text("0");
					$slider.siblings(".not-yet-view").addClass("active");
					$slider.addClass("no-content");
					var $target  = $slider.siblings(".not-yet-view");
					ePrivacyCookies.view('load', 'recently-viewed', $target);

					return;
				}
				
			}


			// slider viewed list
			if( sliderItemLength === 0 || sliderItemLength === undefined || sliderItemLength === null ){
				$slider.siblings(".not-yet-view").addClass("active");
				$slider.addClass("no-content");
			}else{
				$slider.slick({
					//rtl:false,
					accessibility : true,
					arrows : true,
					touchMove : false,
					appendArrows : $this.find(".viewed-bundle-handler").find(".quiver")
				});
				$slider.on("afterChange", function(event, slick, currentSlide){
					$counter.children(".stand").text(currentSlide + 1);
				}); 
			}
			
		};
		p.init();
	};

	floatingbanner = function(el){
		var $el = $(el),
			delayTime = $el.attr("data-waiting-time"),
			cookieName = "noMoreToday",
			secondDelayTime = $el.attr("data-waiting-time-second"),
			hideTime = $el.attr("data-hide-time"),
			p =  floatingbanner.prototype;
			
		
		p.init = function(){
			if(p.getCookieValue(cookieName) !== "true"){
				// 20200406 START 구유정 || data-banner-remove 관련 추가
				if($el.attr("data-banner-remove") === "true"){
					$el.remove();
					return;
				}
				// 20200406 END 구유정 || data-banner-remove 관련 추가
				p.waitingTimer();
				p.addEvent();
			}
		};
		
		p.waitingTimer = function(a){
			$el.removeClass("hidden").addClass("waiting").attr("aria-hidden", true);
			$el.find("input.check-no-more").prop("checked", false);
			$el.find("a, button, input").attr('tabindex','-1'); // LGECI-445
			if(typeof a !='undefined'){
				delayTime = a;
			}
			setTimeout(function(){
				$el.removeClass("waiting").addClass("show").removeAttr("aria-hidden");
				$el.find("a, button, input").removeAttr('tabindex'); // LGECI-445
				/*LGEIN-102 20200721 */
				if(COUNTRY_CODE=='in'){
					p.hiddenTimer();
				}
				/*LGEIN-102 20200721 */
			}, delayTime);
		};
		p.hiddenTimer = function(){
			setTimeout(function(){
				$el.removeClass("show").addClass("waiting").attr("aria-hidden", true);
				$el.find("a, button, input").attr('tabindex','-1'); // LGECI-445
				/*LGEIN-102 20200721*/
				if(inPopup&&COUNTRY_CODE=='in'&&p.getCookieValue(cookieName) !== "true"){
					p.waitingTimer(secondDelayTime);
					inPopup=false;
				}else if(!inPopup&&COUNTRY_CODE=='in'&&p.getCookieValue(cookieName) !== "true"){
					p.bakeCookie(cookieName, true);
				}
				/*LGEIN-102 20200721*/
			}, hideTime);
		}
		p.getCookieValue = function(name){
			var ac = getCookie(name); // common.js
			if(ac !== undefined) {
				return ac;
			}else{
				return false;
			}
		};

		p.bakeCookie = function(name, value){
			if(value == true) {
				setCookie(name, value); // common.js
			}else{
				removeCookie(name); // common.js
			}
		};
		p.closeBanner = function(target){
			var target = target || floatingbanners;
			$(target).removeClass("waiting show").addClass("hidden").attr("aria-hidden", true);
			/*LGEIN-102 20200721*/
			if(COUNTRY_CODE=='in'){
				p.bakeCookie(cookieName, true);
			}
			/*LGEIN-102 20200721*/ 
			/*LGEEASTAF-40 20201019*/
			if(COUNTRY_CODE=='eastafrica'){
				p.bakeCookie(cookieName, true);
				sessionStorage.setItem('inBrowser', true);
			}
			/*LGEEASTAF-40 20201019*/ 
		};

		p.addEvent = function(){
			$el.on("change", "input.check-no-more", function(event){
				if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
					// Cookie 사용 가능 시 실행할 스크립트
					p.bakeCookie(cookieName, $(event.target).prop("checked"));
					p.closeBanner();
				} else {
					// Cookie 사용 불가
					// - click : 고정값	 
					ePrivacyCookies.view('click');
				}
			});

			$el.on("click", ".close", function(event){
				p.closeBanner(event.delegateTarget);
			});

			// LGECI-598 Start
			if($el.hasClass('type6')){ // articleFeedbackFlag = Y
				$el.on("click", ".start", function(event){
					$el.addClass('waiting').removeClass('show');
					$('html, body').animate({
					  scrollTop: $('.article-feedback').offset().top
					}, 600, function(){
						$('.feedback-wrap').attr('tabindex','0').focus(); // 웹접근성 focus
					});
				});

				if(!$el.hasClass('hidden')){ // close 클릭 전 scroll sticky 기능 on
					var whereNow, articlePosition;

					$(window).scroll(function(){
						whereNow = $(document).scrollTop();
						articlePosition = Number($('.article-feedback').offset().top) - Number($(window).height());
						// articlePosition : 현재 스크롤 시점에서 window height (browser height) 를 빼줌으로써 article element 노출 시점(floating box hide 시점)의 갭을 줄여줌

						if(whereNow < articlePosition) $el.addClass('show').removeClass('waiting')
						else $el.addClass('waiting').removeClass('show')
					});
				} 
			}
			// LGECI-598 End
		};
		
		p.init();
	};
	
	// LGETESTITF-124 Start
	recentlyView = function(){
		
		let obj = document.querySelector('.right-floating-bar'),
			url = obj.dataset.url,
			rollingArea = obj.querySelector('.rolling-area'),
			$rollingArea = $(obj).find('.rolling-area'),
			p =  recentlyView.prototype;
					
		p.init = function() {
			ajax.call(url, {}, 'json', function(data){
				let modelList = data.modelList;
				
				if (!!modelList) {
					let defaultImg = rollingArea.dataset.defaultImg;
					
					for (var i=0 ; i<modelList.length ; i++) {
						let model = modelList[i];
						let imagePath = !!model.csModelImagePath ? model.csModelImagePath : defaultImg;
		
						let html = '<div class="viewed-item">';
						html += '	<a href="' + model.csSupportLink + '" data-link-area="cs_floating_bar" data-link-name="recently_viewed">';
						html += '		<span class="imagbox">';
						html += '			<img data-src="' + imagePath + '" class="lazyload" alt="' + model.csSalesCode + '" />';
						html += '		</span>';
						html += '		<span class="model-number">' + model.csSalesCode + '</span>';
						html += '	</a>';
						html += '</div>';
						
						rollingArea.insertAdjacentHTML('beforeend', html);
					}
					
					$rollingArea.removeClass('no-content');
					$rollingArea.siblings(".not-yet-view").removeClass("active");
					
				} else {
					$rollingArea.addClass('no-content');
					$rollingArea.siblings(".not-yet-view").addClass("active");
				}
				floatingbar();
			});
		};
		
		p.init();
	};
	
	recentlyView();
	// LGETESTITF-124 End

	// floatingbanners
	var floatingbanners = document.querySelectorAll(".feedback-floating-banner");
	$(floatingbanners).each(function(){
		floatingbanner(this);
	});
});
//LGECS-150 start
window.onload = function(){
	var float_list = $(".right-floating-bar .bar-menu-list .bar-menu-head a");
	var alias = "rightFloating_";

	for( var i=0; i<float_list.length; i++){
		if( $(float_list[i]).find(".icon svg") && $(float_list[i]).find(".head-title")){
			var float_id_title = alias+(i+1);
			$(float_list[i]).find(".icon svg").attr("aria-labelledby",float_id_title);
			$(float_list[i]).find(".head-title").attr("id",float_id_title); 
		}
	}
}
//LGECS-150 end